export default __webpack_public_path__ + "static/media/325.43b182e4.png";